module.exports = __webpack_public_path__ + "static/NERF_Light_it_Up-05f110b4f483504dc369ae72107e7d53.mp4";